// ⚠️ AUTO-GENERATED FILE - DO NOT MODIFY MANUALLY
    // This file was generated by the DTO generator script.
    // Any changes will be overwritten during the next build.

    import { ForcePublishDetails } from '../Classes/ForcePublishDetails';
import { OpenEstimateRequest } from '../Classes/OpenEstimateRequest';
export class UnlockSapSubmittalRequest {
  estimateId: string;
  bsetUserId: string;
  userEmailId: string;
  isCollaborativeEstimate: boolean;
  reSubmittalNotes: string;
  forcePublishDetails: ForcePublishDetails;
  openEstimateRequest: OpenEstimateRequest;
}
